export default __webpack_public_path__ + "static/media/Entercash.fa9c03ec.svg";